import React from 'react';
import Select from 'react-select';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Button, FormControl, Table } from 'react-bootstrap';
import Papa from 'papaparse';

import ApiUiController from '../../../controller/ApiUiController';
import FieldController from '../../../controller/FieldController';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import Config from '../../../config/config';
import Header from '../../../api/Headers';

class ProductImport extends React.Component {

  constructor(props) {
    super(props);
    this.state = { inApiCall: false, headers: [] };

    this.code = reactLocalStorage.getObject(Const.LoggedInUser).default_code;
    this.models = reactLocalStorage.getObject(Const.Model);
    this.fields = this.models.product.fields;

    const fields = FieldController.getFilterFields(this.fields);
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      if(fields[i].field_key === 'status'
        || fields[i].field_key === 'created_by' || fields[i].field_key === 'created_date'
        || fields[i].field_key === 'updated_by' || fields[i].field_key === 'updated_date' ) continue;
      this.fieldList.push({ value: fields[i], label: fields[i].label_name });
    }
    this.data = [];
    this.file = null;

    this.formats = [{ label: 'DD/MM/YYYY HH:mm:ss', value: 1 },
      { label: 'DD/MM/YYYY hh:mm:ss a', value: 2 }];
  }

  onChange = event => {
    const reader = new FileReader();
    reader.onload = async event => {
      const res = Papa.parse(event.target.result);
      if(res.data !== undefined && res.data !== null && res.data.length > 1) {
        const headers = [];
        this.data = res.data;
        for(let i = 0; i < res.data[0].length; i++) {
          const key = res.data[0][i];
          const field = this.fieldList.find( field => key.trim() === field.label);
          let format = '';
          if(field) {
            if(field.value.field_type === Const.DateTime) format = 'DD/MM/YYYY HH:mm:ss';
            else if(field.value.field_type === Const.Date) format = 'DD/MM/YYYY';
          }
          headers.push({ key, field, format });
        }
        this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
      } else this.setState({ ...this.state, inApiCall: false, headers: [ ] });
    };
    if(event.target.files.length !== 0) {
      this.setState({ ...this.state, inApiCall: true });
      this.file = event.target.files[0];
      reader.readAsText(event.target.files[0]);
    }
  }

  onDemoDownload = () => {
    let csv = '';
    this.fieldList.forEach(field => csv += (csv !== '' ? ', ' : '') + field.label);
    const element = document.createElement('a');
    element.href = URL.createObjectURL(new Blob([csv], {type: 'text/plain'}));
    element.download = 'demo.csv';
    document.body.appendChild(element);
    element.click();
  }

  onSelectChange = (i, select) => {
    const headers = [ ...this.state.headers ];
    headers[i].field = select;

    if(select) {
      if(select.value.field_type === Const.DateTime) headers[i].format = 'DD/MM/YYYY HH:mm:ss';
      else if(select.value.field_type === Const.Date) headers[i].format = 'DD/MM/YYYY';
      else headers[i].format = '';
    } else headers[i].format = '';

    this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
  }

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true});
    new Promise(async resolve => {
      const headers = this.state.headers;
      const products = [];
      for(let i = 1; i < this.data.length; i++) {

        let product = { };
        for(let j = 0; j < headers.length; j++) {

          if(!headers[j].field) continue;

          let value = this.data[i][j];
          
          if(!value) continue;
          let field = headers[j].field.value;
          const key = field.field_key;
          const type = field.field_type;

          if(type === Const.Text || type === Const.TextArea || type === Const.Number) {
            product[key] = value;
          } else if(type === Const.Phone) {
            if(value !== undefined && value !== null && value.trim() !== '') {
              product[key] = product[key] ? `${product[key]}${this.code}-${value}~` :
                `~${this.code}-${value}~`;
            }
          } else if(type === Const.Email || type === Const.Website) {
            if(value !== undefined && value !== null && value.trim() !== '') {
              product[key] = product[key] ? `${product[key]}${value}~` : `~${value}~`;
            }
          } else if(type === Const.Select) {
            const option = field.options.find(option => option.label.toLowerCase()
              === value.toLowerCase());
            if(option) product[key] = option.value;
          } else if(type === Const.MultiSelect) {
            const values = value.split(',');
            let tmp = [];
            for(let i = 0; i < values.length; i++) {
              const option = field.options.find(option => option.label.toLowerCase()
                === values[i].toLowerCase());
              if(option) tmp.push(option.value);
            }
            if(tmp.length !== 0) {
              product[key] = product[key] ? `${product[key]}${tmp.join(Const.Opt)}~` :
                `~${tmp.join(Const.Opt)}~`;
            }
          } else if(type.includes(Const.MultiSelect)) {
            const values = value.split(Const.Opt);
            const module = type.split(Const.Opt)[1];
            let tmp = [];
            for(let i = 0; i < values.length; i++) {
              const option = this.models[module].options.find(option => option.label.toLowerCase()
                === values[i].toLowerCase());
              if(option !== undefined) tmp.push(option.value);
            }
            if(tmp.length !== 0) {
              product[key] = product[key] ? `${product[key]}${tmp.join(Const.Opt)}~` :
                `~${tmp.join(Const.Opt)}~`;
            }
          } else if(type.includes(Const.Select)) {
            const module = type.split(Const.Opt)[1];
            const option = this.models[module].options.find(option => option.label.toLowerCase()
              === value.toLowerCase());
            if(option) product[key] = option.value;
          } else if(type === Const.DateTime) {
            product[key] = Util.serverImport(value, 'DD/MM/YYYY HH:mm:ss');
          } else if(type === Const.Date) {
            product[key] = Util.serverImport(value + ' 10:00:00', 'DD/MM/YYYY');
          } else {
            console.log(key, field);
          }
        }
        products.push(product);
      }

      const file = new Blob([JSON.stringify(products)], {type: 'text/html'});
      const medias = [{ ref: 0, model_no: 23, model_id: 0, type: 'json', size: file.size },
        { ref: 1, model_no: 23, model_id: 0, type: 'csv', size: this.file.size }];
      const files = [file, this.file];
      const resMedias = await new Promise(resolve => {
        fetch(Config.app.link + 'api/media/put-private', new Header('POST', medias))
        .then(res => {
          if(res.status === Const.Success200) { res.json().then(result => resolve(result)); }
          else { res.json().then(er => Util.showError(er)); }
        }).catch(er => Util.showError(er));
      });
      await new Promise(resolve => fetch(resMedias[0].signed,
        { method: 'PUT', body: files[resMedias[0].ref] }).then(res => resolve(res)));
      await new Promise(resolve => fetch(resMedias[1].signed,
        { method: 'PUT', body: files[resMedias[1].ref] }).then(res => resolve(res)));

      const auth = reactLocalStorage.get(Const.System);
      const user = reactLocalStorage.getObject(Const.LoggedInUser).id;
      const importJson = { id: 0, module: Const.Product, import_status: 1, auth, user,
        import_file: resMedias[1].ref === 0 ? resMedias[0].id : resMedias[1].id,
        result_json: resMedias[0].ref === 1 ? resMedias[1].id : resMedias[0].id };
      await new Promise(resolve => {
          fetch(Config.app.link + 'api/import', new Header('POST', importJson))
          .then(res => {
            if(res.status === Const.Success200) { res.json().then(result => resolve(result)); }
            else { res.json().then(er => Util.showError(er)); }
          }).catch(er => Util.showError(er));
        });
			resolve();
		}).then(res => {
      this.setState({ ...this.state, inApiCall: true});
      this.props.navigate('/setting/import');
    });
  }

  render() {
    const fields = this.state.headers.map((header, i) => 
      <tr key={`crm_field_${i}`}>
        <td>{header.key}</td>
        <td>
          <Select value={header.field} onChange={select => this.onSelectChange(i, select)}
            options={this.fieldList} isSearchable={true} isClearable={true} />
        </td>
        <td> {header.format} </td>
      </tr>
    );

    return (
      <div className="sectionform">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-6">
            <p class="mb-0"><small> Click Here To Download Lead Format</small></p>
              <Button variant="success" onClick={this.onDemoDownload} className="pt-2 pb-2 ml-0 mr-0">Demo CSV</Button>
              <FormControl type="file" onChange={this.onChange} className="pt-2 pb-2" /><p><small>Only CSV Format Supported</small></p>
            </div>
          </div>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="row">
              <div className="col-md-6 pb-3"><h3>Fields</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><th>CSV Field</th><th>CRM Field</th><th>Format</th></tr></thead>
                  <tbody>{fields}</tbody>
                </Table>
              </div>
              { this.state.headers.length !== 0 &&
                <div className="col-md-12 text-center btnsend">
                  <Button variant="success" onClick={this.onSave}>Import</Button>
                </div>
              }
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ProductImport);